import { createGlobalStyle } from 'styled-components'
import { theme } from '@mrshmllw/smores-react'

import UKNumberPlateFont from 'assets/fonts/UKNumberPlate.ttf'

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Circular';
    src: url('https://assets.marshmallow.com/fonts/CircularXXSub-RegularSubset.woff2') format('woff2');
    font-weight: ${theme.font.weight.normal};
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Circular';
    src: url('https://assets.marshmallow.com/fonts/CircularXXWeb-Medium.woff2') format('woff2');
    font-weight: ${theme.font.weight.medium};
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Circular';
    src: url('https://assets.marshmallow.com/fonts/CircularXXWeb-Bold.woff2') format('woff2');
    font-weight: ${theme.font.weight.bold};
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MarshmallowYouth';
    src: url('https://assets.marshmallow.com/fonts/MarshmallowYouth-Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'UKNumberPlate';
    src: url('${UKNumberPlateFont}') format('truetype');
    font-weight: 400;
    font-display: fallback;
  }

  * {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-tap-highlight-color: transparent;
    font-family: 'Circular', ${theme.font.system};

    &:focus {
      outline: none;
    }
  }

  html,
  body,
  #root {
    height: 100%;
    background-color: ${theme.colors.coconut};
  }

  a{text-decoration:none; color:inherit; cursor:pointer;}
  input::-moz-focus-inner {border:0;}
  ul, ol, dd{list-style:none;}
  h1, h2, h3, h4, h5, h6{font-size:inherit; font-weight:inherit;}

  button {
    border: none;
    outline: none;
    background: none;
  }
  
  dialog {
    border: none;
    outline: none;
    background: none;
  }

  svg { -webkit-transform: translate3d(0,0,0); }

  html {
    box-sizing: border-box;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`
